import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoInVision = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 124 48"
    {...props}
  >
    <g clipPath="url(#Logo_InVision_svg__a)">
      <path
        fill="#F36"
        d="M52.836 18.336h4.67L50.87 35.047h-4.178l-6.758-16.71h4.792l4.055 11.18zm6.144 16.588h4.546V18.336H58.98zm6.635-5.406h4.546c.123 1.106.86 2.212 2.826 2.212 1.72 0 2.58-.615 2.58-1.475 0-2.826-9.215-.123-9.215-6.758 0-3.072 2.58-5.53 6.635-5.53 5.038 0 6.758 3.195 6.881 5.653h-4.3c-.123-1.106-.86-1.966-2.458-1.966-1.474 0-2.334.737-2.334 1.597 0 2.826 9.215 0 9.215 6.881 0 2.95-2.58 5.284-7.004 5.284-5.283-.123-7.126-2.703-7.372-5.898m16.588 5.406h4.546V18.336h-4.546zm15.236-3.563c2.335 0 4.178-1.72 4.178-4.792 0-2.95-1.843-4.792-4.178-4.792s-4.177 1.72-4.177 4.792 1.843 4.792 4.177 4.792m-8.724-4.792c0-4.792 3.44-8.724 8.724-8.724s8.724 3.932 8.724 8.724-3.44 8.724-8.724 8.724c-5.283 0-8.724-3.932-8.724-8.724m23.715-6.267c.737-1.474 2.457-2.457 4.915-2.457 4.055 0 6.144 2.703 6.144 6.635v10.444h-4.547v-9.953c0-1.966-.86-3.317-2.826-3.317-2.212 0-3.44 1.351-3.44 3.686v9.584h-4.547V18.336h4.301z"
      />
      <path
        fill="#F36"
        d="M.615 45h41.9V3.1H.615z"
      />
      <path
        fill="#fff"
        d="M15.36 16.248c1.351 0 2.457-.983 2.457-2.458a2.465 2.465 0 0 0-2.457-2.457c-1.352 0-2.458.983-2.458 2.457 0 1.475 1.106 2.458 2.458 2.458m-5.161 13.025c-.123.614-.246 1.228-.246 1.843 0 2.089 1.106 3.563 3.564 3.563 2.088 0 3.686-1.229 4.915-3.195l-.738 2.95h4.055l2.335-9.216c.614-2.335 1.72-3.564 3.44-3.564 1.352 0 2.212.86 2.212 2.212 0 .369 0 .86-.123 1.352l-1.229 4.3c-.122.615-.245 1.23-.245 1.843 0 1.966 1.228 3.44 3.686 3.44 2.089 0 3.809-1.35 4.792-4.668l-1.597-.615c-.738 2.212-1.475 2.58-1.967 2.58-.491 0-.86-.368-.86-1.105 0-.369.123-.737.123-1.106l1.106-4.178q.369-1.474.369-2.58c0-3.072-1.843-4.67-4.178-4.67-2.089 0-4.3 1.967-5.406 3.933l.737-3.564H18.8l-.86 3.195h2.826l-1.72 6.758c-1.352 3.072-3.932 3.195-4.3 3.072-.492-.123-.86-.369-.86-.983 0-.369.122-.983.245-1.597l2.703-10.69h-6.758l-.86 3.194h2.826z"
      />
    </g>
    <defs>
      <clipPath id="Logo_InVision_svg__a">
        <path
          fill="#fff"
          d="M.615 0h123v48h-123z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoInVision;
